



































































































































import Vue from "vue";

import DictionarySentence from "@tt-app/components/exercise/SingleSentenceReading/DictionarySentence.vue";
import IntonationSentence from "@tt-app/components/exercise/SingleSentenceReading/IntonationSentence.vue";
import ReviewSentence from "@tt-app/components/exercise/SingleSentenceReading/ReviewSentence.vue";
import SingleSentenceReadingTrophy from "@tt-app/components/exercise/SingleSentenceReading/SingleSentenceReadingTrophy.vue";

import IconCheckbox from "@joyz/app-core/assets/icons/default/Checkbox.svg";
import IconCheckboxActive from "@joyz/app-core/assets/icons/active/Checkbox.svg";
import IconCheckboxIndeterminate from "@joyz/app-core/assets/icons/active/CheckboxIndeterminate.svg";
import {
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

interface Data {
  icons: Record<string, any>;
}

interface Methods {
  sentenceSelectionHandler: (problemUuid: string) => void;
}

interface Computed {
  checkboxAvailable: boolean;
  checkboxIcon: string;
  checkboxLabel: string;
  fluencyCommentString: string;
  limitedModeActive: boolean;
}

interface Props {
  answers: any;
  audioConfig: {
    accent: number;
    speed: number;
  };
  audioProgress: number;
  collectiveCheckboxClickHandler: () => void;
  evaluations: any;
  exerciseResult: {
    moreScore: number;
    prevBestTrophy: number;
    trophy: number;
  };
  exerciseSentences: any;
  logId: number;
  practiceAgainUuids: any;
  practiceMode: boolean;
  exampleAudioButtonClickHandler: () => void;
  trophyScores: any;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SingleSentenceReadingReview",
  components: {
    DictionarySentence,
    IntonationSentence,
    ReviewSentence,
    SingleSentenceReadingTrophy
  },
  props: {
    answers: {
      type: Object,
      required: true
    },
    audioConfig: {
      type: Object,
      required: true
    },
    audioProgress: {
      type: Number,
      required: true
    },
    collectiveCheckboxClickHandler: {
      type: Function,
      default: () => undefined
    },
    evaluations: {
      type: Object,
      default: undefined
    },
    exerciseResult: {
      type: Object,
      default: () => ({
        moreScore: 0,
        prevBestTrophy: 0,
        trophy: 0
      })
    },
    exerciseSentences: {
      type: Array,
      required: true
    },
    logId: {
      type: Number,
      default: undefined
    },
    practiceAgainUuids: {
      type: Array,
      required: true
    },
    practiceMode: {
      type: Boolean,
      default: false
    },
    exampleAudioButtonClickHandler: {
      type: Function,
      required: true
    },
    trophyScores: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icons: {
        active: {
          checkbox: IconCheckboxActive,
          indeterminate: IconCheckboxIndeterminate
        },
        default: {
          checkbox: IconCheckbox
        }
      }
    };
  },
  computed: {
    checkboxAvailable() {
      return !this.limitedModeActive;
    },
    checkboxIcon() {
      if (this.practiceAgainUuids.length === 0) {
        return this.icons.default.checkbox;
      }

      if (this.exerciseSentences.length === this.practiceAgainUuids.length) {
        return this.icons.active.checkbox;
      }

      return this.icons.active.indeterminate;
    },
    checkboxLabel() {
      if (this.exerciseSentences.length === this.practiceAgainUuids.length) {
        return "全て解除";
      }

      return "全て選択";
    },
    fluencyCommentString() {
      const score = this.trophyScores.fluency;

      switch (true) {
        case score >= 80:
          return "exercise.single-sentence-reading.fluency.high";
        case score >= 50 && score < 80:
          return "exercise.single-sentence-reading.fluency.middle";
        default:
          return "exercise.single-sentence-reading.fluency.low";
      }
    },
    limitedModeActive() {
      const session = this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];

      return Boolean(session?.limitedMode?.id);
    }
  },
  methods: {
    sentenceSelectionHandler(problemUuid) {
      this.$emit("sentence-selected", problemUuid);
    }
  }
});
